import { videoApis } from '@/api/video';
import { createAsyncThunk } from '@reduxjs/toolkit';

import type { ICourseInitialState, IThunkAPI } from '../types';

export const initialState: ICourseInitialState = {
  courseList: undefined,
};

export const getAccessToken = createAsyncThunk<unknown, number, IThunkAPI>(
  'video/accesstoken',
  async (interviewId, thunkAPI) => {
    try {
      const response = await videoApis.getAccessToken(interviewId);

      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getRoomHasParticipants = createAsyncThunk<unknown, number, IThunkAPI>(
  'video/participants',
  async (interviewId, thunkAPI) => {
    try {
      const response = await videoApis.getRoomHasParticipants(interviewId);

      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
